module.exports = __webpack_public_path__ + "img/Eth-icon.b9a124f8.png";